module.exports = __webpack_public_path__ + "img/mariusli.f6b23527.jpeg";